import { render, staticRenderFns } from "./TaskInteractions.vue?vue&type=template&id=df2a01f6&"
import script from "./TaskInteractions.vue?vue&type=script&lang=js&"
export * from "./TaskInteractions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports